"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactCsv = require("react-csv");

var SkuCsvDownloadLink = function SkuCsvDownloadLink(_ref) {
  var skus = _ref.skus,
      message = _ref.message;
  var csvData = skus.map(function (sku) {
    return [sku];
  });
  return _react["default"].createElement(_reactCsv.CSVLink, {
    data: csvData,
    filename: "SKUs_".concat(new Date().toISOString(), ".csv")
  }, message ? message : 'Download SKUs');
};

var _default = SkuCsvDownloadLink;
exports["default"] = _default;